module.exports = {"513432100":"光明镇","513432101":"冕山镇","513432102":"红莫镇","513432103":"两河口镇","513432104":"米市镇","513432105":"洛哈镇","513432106":"尼波镇","513432200":"拉克乡","513432201":"则约乡","513432202":"贺波洛乡","513432203":"鲁基乡","513432204":"李子乡","513432205":"北山乡","513432206":"西河乡","513432207":"东河乡","513432208":"且拖乡","513432209":"博洛拉达乡","513432210":"沙马拉达乡","513432211":"巴久乡","513432212":"洛莫乡","513432213":"依洛乡","513432214":"热柯依达乡","513432215":"额尼乡","513432216":"乐武乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/513432.json
// module id = 2441
// module chunks = 0